import type { FC, ReactNode } from 'react'

import Head from 'next/head'
import { Layout } from '@/components/generals/layout'
import { Seo } from '@/components/generals/seo'
import { BenefitsSection } from '@/components/landing/benefits-section'
import { ContactSection } from '@/components/landing/contact-section'
import { FaqSection } from '@/components/landing/faq-section'
import { HeroSection } from '@/components/landing/hero-section'
import { ProcessSection } from '@/components/landing/process-section'
import { ReferenceSection } from '@/components/landing/reference-section'
import { ServicesSection } from '@/components/landing/services-section'
import { StandardsStrip } from '@/components/landing/standards-strip'
import { TeamSection } from '@/components/landing/team-section'
import { TechnologySection } from '@/components/landing/technology-section'
import { UseCasesSection } from '@/components/landing/use-cases-section'
import { company } from '@/constants/company'
import { FAQS } from '@/constants/content'
import { siteConfig } from '@/constants/site'

const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
        {
            '@type': 'Organization',
            '@id': `${siteConfig.url}/#organisation`,
            name: siteConfig.name,
            legalName: company.legalName,
            url: siteConfig.url,
            email: company.email,
            telephone: company.phone,
            address: {
                '@type': 'PostalAddress',
                streetAddress: company.street,
                postalCode: company.postalCode,
                addressLocality: company.city,
                addressCountry: 'DE'
            },
            areaServed: ['DE', 'AT', 'CH'],
            sameAs: siteConfig.links?.linkedin ? [siteConfig.links.linkedin] : []
        },
        {
            '@type': 'Service',
            name: 'Betontemperatur-Monitoring',
            serviceType: 'Temperaturüberwachung von Betonbauteilen auf Baustellen',
            provider: { '@id': `${siteConfig.url}/#organisation` },
            areaServed: ['DE', 'AT', 'CH']
        },
        {
            '@type': 'FAQPage',
            mainEntity: FAQS.map((faq) => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: faq.answer.join(' ')
                }
            }))
        }
    ]
}

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo title='Betontemperatur-Monitoring für Baustellen' />

            <Head>
                <script
                    type='application/ld+json'
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
                />
            </Head>

            <HeroSection />
            <StandardsStrip />
            <BenefitsSection />
            <ServicesSection />
            <TechnologySection />
            <UseCasesSection />
            <ProcessSection />
            <ReferenceSection />
            <TeamSection />
            <FaqSection />
            <ContactSection />
        </Layout>
    )
}

export default Home
